<template>
  <img :src="imageSource" :fetchpriority="preload ? 'high' : undefined" />
</template>

<script lang="ts" setup>
import * as z from "zod";
const config = useRuntimeConfig();

type Props = {
  src: string;
  preload?: boolean;
};
const props = defineProps<Props>();

const imageSource = computed(() => {
  const urlSchema = z.string().url();
  const isValidUrl = urlSchema.safeParse(props.src).success;
  return isValidUrl ? props.src : config.public.assetBaseUrl + props.src;
});

// Preload image if `preload` prop is true
useHead(() => ({
  link: props.preload
    ? [
        {
          rel: "preload",
          as: "image",
          href: imageSource.value,
        },
      ]
    : [],
}));
</script>
